module.exports = __webpack_public_path__ + "80e3dd43a89f6cc3ccb8c8282d676dd1.MP3";